import React, { useState } from 'react'
import { Marker, InfoWindow } from "@react-google-maps/api"
import { obterEndereco } from '../../api/GeocodeApi'

export default function Mapa(props) {

    const [selected, setSelected] = useState(true)

    if (!props.dados.isMarkerShow) {
        return false
    }

    const onMarkerDragEnd = event => {
        const newLat = event.latLng.lat()
        const newLng = event.latLng.lng()
        obterEndereco({ gps:{ lat:newLat, lng:newLng } })
        .then( resposta => {
            props.setDados({ 
                ...props.dados, 
                isMarkerShow:true, 
                address:resposta.address, 
                endereco:resposta.endereco 
            })
            console.log(resposta)
        })
        .catch( msgErro => {
            console.log(msgErro)
        })
    }

    const renderInfoWindow = () => {
        if (!selected) {
            return null
        }

        return(
            <InfoWindow onCloseClick={ () => setSelected(false) }> 
                <div><strong>{ props.dados.address }</strong></div>
            </InfoWindow>
        )
    }
    
    return (
        <Marker 
            position={{ lat:props.dados.endereco.latitude, lng:props.dados.endereco.longitude }} 
            draggable={ true }
            onClick={ () => setSelected(!selected) }
            onDragEnd={ onMarkerDragEnd }
        >
            { renderInfoWindow() }
        </Marker>
    )
}